// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flight-lookup .input-container[data-v-59a2197e]{--tw-text-opacity:1;color:#282c4a;color:rgba(40,44,74,var(--tw-text-opacity))}@media (min-width:1024px){.flight-lookup .input-container[data-v-59a2197e]{max-width:22rem}}.flight-lookup .dropdown-scrollable[data-v-59a2197e]{max-height:250px;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
